var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.element.config.__config__.isTitle)?_c('div',{staticClass:"type-label"},[_vm._v(_vm._s(_vm.element.config.__config__.label))]):_c('div',{class:_vm.className,style:({ textIndent: _vm.element.config.__config__.labelWidth + 'px' })},[_vm._v(_vm._s(_vm.element.config.__config__.label)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }